/**
 * 中药处方划价模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增中药处方划价单 --- 馆内、电子处方
export const drugPaymentAdd1 = (params) => {
  return req.post('/order/payment/drug', params);
}

// 新增中药处方划价单 手写、补录 --- 馆内、手写处方
export const drugPaymentAdd2 = (params) => {
  return req.post('/order/payment/drug/handwritten', params);
}

// 新增中药处方划价单 自建收费、微信拍单 --- 馆内/馆外、手写处方
export const drugPaymentAdd3 = (params, uuid, code) => {
  return req.post(`/order/payment/drug/insert?uuid=${uuid}&code=${code}`, params);
}

// 修改中药划价单
export const drugPaymentEdit = (params) => {
  return req.put('/order/payment/drug', params);
}

// 查询中药处方划价单列表
export const drugPaymentList = (params) => {
  return req.post(`/order/payment/paymentPage`, params);
}
// export const drugPaymentList = (params) => {
//   return req.get(`/order/payment/drug/list`, params);
// }

// 查询中药处方划价单状态数量
export const statusNumDrug = (params) => {
  return req.get(`/order/payment/drug/statusNumber`, params);
}

// 中药划价单付款
export const drugPaymentPay = (params) => {
  return req.post(`/order/payment/drug/payment`, params);
}

// 多条中药处方划价单付款
export const paymentAllDrug = (list) => {
  return req.post('/order/payment/drug/payments', list);
}

// 根据中药处方id获取中药处方划价单详情
export const drugPaymentInfo = (recipeDrugId, orderId) => {
  return req.get(`/order/payment/drug/recipe/${recipeDrugId}/${orderId}`);
}

// 根据中药处方划价单id删除中药处方划价单
// export const drugPaymentDelete = (orderPaymentRecipeDrugIds) => {
//   return req.delete(`/order/payment/drug/${orderPaymentRecipeDrugIds}`);
// }
export const drugPaymentDelete = (params) => {
  return req.delete(`/order/payment/drug`,params);
}

// 根据中药处方划价单id作废中药处方划价单
// export const drugPaymentInvalid = (orderPaymentRecipeDrugId, value) => {
//   return req.post(`/order/payment/drug/invalid/${orderPaymentRecipeDrugId}/${value}`);
// }
export const drugPaymentInvalid = (params) => {
  return req.post(`/order/payment/drug/invalid`,params);
}

// 根据中药处方划价单信息退款 --- 线下支付
export const drugPaymentRefund = (params) => {
  return req.post(`/order/payment/drug/refund`, params);
}

// 根据中药处方划价单id退款 --- 微信支付
export const drugPaymentRefund1 = (orderPaymentRecipeDrugId) => {
  return req.post(`/wechat/pay/paymentRefund/${orderPaymentRecipeDrugId}`);
}

// 根据中药处方划价单id获取中药处方划价单详情
export const drugPaymentDetails = (paymentRecipeDrugId) => {
  return req.get(`/order/payment/drug/${paymentRecipeDrugId}`);
}

// 根据中药处方划价单id获取中药处方划价单小票信息
export const drugSmallTicket = (id) => {
  return req.get(`/order/payment/drug/printCharge/${id}`);
}

// 根据中药处方划价单id获取中药处方打印详情
export const drug = (orderPaymentRecipeDrugId, type) => {
  return req.get(`/order/payment/drug/printRecipe/${orderPaymentRecipeDrugId}/${type}`);
}

// 根据中药处方拍单id获取中药处方划价单详情
export const drugPaymentDetailByAuctionId = (auctionId) => {
  return req.get(`/order/payment/drug/auction/${auctionId}`);
}

// 根据中药处方划价单id获取扭转单数据
export const reverseDrug = (orderPaymentRecipeDrugId) => {
  return req.get(`/order/payment/drug/printOrder/${orderPaymentRecipeDrugId}`);
}

// 根据中药处方划价单id获取同城快递单数据
export const deliveryDrugTC = (orderPaymentRecipeDrugId) => {
  return req.get(`/order/payment/drug/printDelivery/${orderPaymentRecipeDrugId}`);
}

// 根据中药处方划价单id获取顺丰快递单数据
export const deliveryDrugSF = (orderPaymentRecipeDrugId) => {
  return req.get(`/sfexpress/order/getOrderPrint/${orderPaymentRecipeDrugId}/1`);
}

// 修改中药处方划价单物流信息
export const deliveryDrugEdit = (params) => {
  return req.put(`/order/payment/drug/updateOrderByDelivery`, params);
}